import { LinkTo } from "@pharmupp/p3-front-commons"

export const AgendaListEventsLink = ({ to }: { to: string }) => (
  <LinkTo
    to={to}
    name="VOIR TOUS"
    chevronSize={14}
    nameSx={{ sx: { color: (t) => t.palette.success.main }, variant: "12px" }}
    containerSx={{ display: "flex", justifyContent: "flex-end" }}
  />
)
